export function agruparEvento(data, tipo, fechaKey, nroKey, incluirTS = true) {
  const map = {};
  data.forEach((item) => {
    const fecha = item[fechaKey] || "SIN FECHA";
    const ts = incluirTS ? item.CreateTS || null : null;
    const key = `${fecha}-${ts}-${item[nroKey]}`;

    if (!map[key]) {
      map[key] = {
        tipo,
        fecha,
        ts,
        numero: item[nroKey] || "?",
        cantidad: 0,
        pendiente: 0,
        data: [],
      };
    }

    map[key].cantidad += parseFloat(item.Quantity || 0);
    map[key].pendiente += parseFloat(item["Cantidad Pendiente"] || 0);
    map[key].data.push(item);
  });

  return Object.values(map);
}
